(function(){
  'use strict';

  var root = document.getElementById('epack-b2b-offer');
  if (!root || window.__epackB2BOfferLoaded) return;
  window.__epackB2BOfferLoaded = true;

  var portalId = root.dataset.hsPortalId;
  var formGuid = root.dataset.hsFormGuid;
  var couponCode = root.dataset.couponCode || '100B2B';
  var submitEndpoint = 'https://api.hsforms.com/submissions/v3/integration/submit/' + portalId + '/' + formGuid;
  var pageType = root.dataset.pageType || '';
  var templateName = root.dataset.templateName || '';
  var storagePrefix = 'epack_b2b_offer_';
  var now = Date.now();
  var openedAt = now;
  var hasShown = false;
  var scrollTriggered = false;
  var exitTriggered = false;

  function getParam(name){ return new URLSearchParams(window.location.search).get(name) || ''; }
  function getCookie(name){
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : '';
  }
  function setWithTTL(key, value, days){
    localStorage.setItem(storagePrefix + key, JSON.stringify({ value:value, expires: Date.now() + days*864e5 }));
  }
  function getWithTTL(key){
    try{
      var raw = localStorage.getItem(storagePrefix + key);
      if(!raw) return null;
      var item = JSON.parse(raw);
      if(item.expires && Date.now() > item.expires){ localStorage.removeItem(storagePrefix + key); return null; }
      return item.value;
    } catch(e){ return null; }
  }
  function rememberLanding(){
    if(!sessionStorage.getItem('epack_b2b_landing_page')) sessionStorage.setItem('epack_b2b_landing_page', window.location.href);
  }
  rememberLanding();

  function isExcludedRoute(){
    var path = window.location.pathname || '';
    if (path.indexOf('/cart') === 0) return true;
    if (path.indexOf('/checkout') === 0) return true;
    if (path.indexOf('/account') === 0) return true;
    if (path.indexOf('/pages/b2b-registration') === 0) return true;
    if (path.indexOf('/pages/business-registration') === 0) return true;
    return false;
  }
  function shouldSuppress(){
    // Production targeting: don't show to logged-in customers, repeat submitters,
    // recent dismissers, or visitors mid-checkout / on the B2B registration page.
    if (root.dataset.customerLoggedIn === 'true') return true;
    if (getWithTTL('submitted')) return true;
    if (getWithTTL('dismissed')) return true;
    if (isExcludedRoute()) return true;
    return false;
  }
  function show(mode){
    if(hasShown || shouldSuppress()) return;
    hasShown = true;
    root.classList.add('is-visible');
    if(mode === 'modal') root.classList.add('is-modal');
    root.setAttribute('aria-hidden','false');
    openedAt = Date.now();
  }
  function close(){
    root.classList.remove('is-visible','is-modal');
    root.setAttribute('aria-hidden','true');
    setWithTTL('dismissed', '1', 3);
  }
  function showScreen(name){
    root.querySelectorAll('[data-b2b-screen]').forEach(function(el){ el.classList.toggle('is-active', el.dataset.b2bScreen === name); });
    root.querySelectorAll('[data-b2b-error]').forEach(function(el){ el.textContent=''; el.classList.remove('is-visible'); });
  }
  function showError(form, msg){
    var err = form.querySelector('[data-b2b-error]');
    if(err){ err.textContent = msg; err.classList.add('is-visible'); }
  }
  function collect(form){
    // Collect all form values; checkbox groups become a comma-joined string.
    var data = {};
    var fd = new FormData(form);
    var keys = {};
    fd.forEach(function(value, key){ keys[key] = true; });
    Object.keys(keys).forEach(function(key){
      var values = fd.getAll(key).filter(function(v){ return v !== ''; });
      data[key] = values.length > 1 ? values.join(', ') : (values[0] || '');
    });
    return data;
  }
  function field(name, value){ return { name:name, value: value == null ? '' : String(value) }; }
  function buildContextMessage(path, data){
    var userMsg = (data.message || '').trim();
    var lines = [];
    if (userMsg) { lines.push(userMsg, ''); }
    lines.push(
      '— B2B Offer context —',
      'Offer path: ' + path,
      'Offer: $100 off first $1,000+ business order (code emailed after submission)',
      'Packaging type(s): ' + (data.packaging_types || ''),
      'Quantity tier: ' + (data.quantity_needed_tiered || ''),
      'Submitted page: ' + window.location.href,
      'Landing page: ' + (sessionStorage.getItem('epack_b2b_landing_page') || ''),
      'Page title: ' + document.title,
      'Page type: ' + pageType,
      'UTM source: ' + getParam('utm_source'),
      'UTM medium: ' + getParam('utm_medium'),
      'UTM campaign: ' + getParam('utm_campaign'),
      'GCLID: ' + getParam('gclid'),
      'MSCLKID: ' + getParam('msclkid')
    );
    return lines.join('\n');
  }
  function submitToHubSpot(path, data){
    // Map the popup's checkbox-collected packaging_types → existing HubSpot contact property
    // (packaging_type_s___lid__tub__pouch__etc__). This keeps downstream workflows unchanged.
    var fields = [
      field('email', data.email),
      field('firstname', data.firstname),
      field('lastname', data.lastname),
      field('company', data.company),
      field('phone', data.phone),
      field('packaging_type_s___lid__tub__pouch__etc__', data.packaging_types),
      field('quantity_needed_tiered', data.quantity_needed_tiered),
      // B2B program fields
      field('b2b_offer_path', path),
      field('b2b_offer_code', couponCode),
      field('b2b_offer_source', 'shopify_b2b_offer_popup'),
      // Core HubSpot / tracking
      field('message', buildContextMessage(path, data)),
      field('landing_page_url', sessionStorage.getItem('epack_b2b_landing_page') || ''),
      field('last_landing_page', window.location.href),
      field('utm_source', getParam('utm_source')),
      field('utm_medium', getParam('utm_medium')),
      field('utm_campaign', getParam('utm_campaign')),
      field('utm_term', getParam('utm_term')),
      field('utm_content', getParam('utm_content')),
      field('gclid', getParam('gclid')),
      field('msclkid', getParam('msclkid'))
    ].filter(function(f){ return f.value !== ''; });

    return fetch(submitEndpoint, {
      method:'POST',
      headers:{ 'Content-Type':'application/json' },
      body: JSON.stringify({
        fields: fields,
        context: {
          hutk: getCookie('hubspotutk'),
          pageUri: window.location.href,
          pageName: document.title
        }
      })
    }).then(function(res){
      if(!res.ok){
        return res.text().then(function(t){
          console.error('[B2B popup] HubSpot submit HTTP', res.status, t);
          throw new Error(t || ('HubSpot submit failed: HTTP ' + res.status));
        });
      }
      return res.json();
    });
  }

  // Self-serve CTA: let the anchor tag handle navigation; just log intent for analytics.
  root.addEventListener('click', function(e){
    var closeBtn = e.target.closest('[data-b2b-close]');
    var backBtn = e.target.closest('[data-b2b-back]');
    var pathBtn = e.target.closest('[data-b2b-path]');
    var ctaAnchor = e.target.closest('[data-b2b-cta="self_serve"]');
    if(closeBtn){ close(); return; }
    if(backBtn){ showScreen('intro'); return; }
    if(pathBtn){ showScreen(pathBtn.dataset.b2bPath); return; }
    if(ctaAnchor){
      setWithTTL('self_serve_clicked','1',30);
      // Do NOT preventDefault — let the anchor navigate to /pages/b2b-registration.
    }
  });

  root.querySelectorAll('[data-b2b-form]').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var path = form.dataset.b2bForm;
      var data = collect(form);
      if(data.website) return;
      if(Date.now() - openedAt < 1200){ showError(form, 'Please wait a moment and try again.'); return; }
      if(!data.firstname || !data.lastname || !data.email || !data.company || !data.phone || !data.message){
        showError(form, 'Please complete the required fields.');
        return;
      }
      var btn = form.querySelector('button[type="submit"]');
      var old = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Submitting…';
      submitToHubSpot(path, data).then(function(){
        setWithTTL('submitted','1',30);
        showScreen('success_sales_help');
      }).catch(function(err){
        console.error('[B2B popup] submit failed', err);
        showError(form, 'Something went wrong. Please try again or call us for help.');
      }).finally(function(){
        btn.disabled = false;
        btn.textContent = old;
      });
    });
  });

  // Production triggers: time-delay (first fire) OR exit-intent OR scroll-depth.
  // First trigger to fire wins; `show()` is idempotent via hasShown + shouldSuppress.
  // Bail entirely if the visitor is suppressed (logged in, recent submit/dismiss, excluded route).
  if (!shouldSuppress()) {
    // Time-delay trigger: 2s after load.
    setTimeout(function(){ show('modal'); }, 2000);

    // Exit-intent trigger: mouse leaves viewport heading up (toward tab/close).
    document.addEventListener('mouseleave', function(e){
      if (exitTriggered || hasShown || e.clientY > 0) return;
      exitTriggered = true;
      show('modal');
    });

    // Scroll-depth trigger: once the visitor scrolls past 45% of the page, fire.
    // Catches mobile + engaged readers who never trigger mouseleave.
    window.addEventListener('scroll', function(){
      if (scrollTriggered || hasShown) return;
      var doc = document.documentElement;
      var scrolled = (window.scrollY || doc.scrollTop || 0) + window.innerHeight;
      var total = Math.max(doc.scrollHeight, doc.offsetHeight, document.body.scrollHeight);
      if (total <= 0) return;
      if ((scrolled / total) >= 0.45) {
        scrollTriggered = true;
        show('modal');
      }
    }, { passive: true });
  }
})();

